import debounce from 'lodash.debounce';
import {Signal} from 'typed-signals';

export default class OneViewScroll {
  top = 20;
  delta = 500;
  status = '';
  private ystart = 0;
  private lock = false;
  private deltaOfInterest = 0;
  private lastAnimation = 0;
  // left: 37, up: 38, right: 39, down: 40,
  // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  private keysUp = {38: 1, 33: 1, 36: 1};
  private keysDown = {40: 1, 32: 1, 34: 1, 35: 1};

  public isDisabled = false;
  public onUp = new Signal<() => void>();
  public onDown = new Signal<() => void>();

  constructor(private document: HTMLElement) {
    this.onMousewheel = this.onMousewheel.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);

    this._init();
  }

  destroy() {
    this.document.removeEventListener('mousewheel', this.onMousewheel);
    this.document.removeEventListener('touchstart', this.onTouchStart);
    this.document.removeEventListener('touchmove', this.onTouchMove);
    this.document.removeEventListener('touchend', this.onTouchEnd);
  }

  static get MOVE_UP() {
    return 'move_up';
  }

  static get MOVE_DOWN() {
    return 'move_down';
  }

  _init() {
    // DOMMouseScroll MozMousePixelScroll',
    this.onMousewheel = debounce(this.onMousewheel, 10, {
      // leading: true,
      // trailing: true,
    });
    const mousewheelevent =
      'onwheel' in document
        ? 'wheel'
        : 'onmousewheel' in document
        ? 'mousewheel'
        : 'DOMMouseScroll';
    try {
      this.document.addEventListener(mousewheelevent, this.onMousewheel);
    } catch (e) {
      //for legacy IE
      this.document.attachEvent('onmousewheel', this.onMousewheel);
    }
    // this.document.addEventListener('mousewheel', this.onMousewheel)
    this.document.addEventListener('touchstart', this.onTouchStart);
    this.document.addEventListener('touchmove', this.onTouchMove);
    this.document.addEventListener('touchend', this.onTouchEnd);

    document.onkeydown = function (e) {
      if (this.keysUp[e.keyCode]) {
        this._moveUp();
      }
      if (this.keysDown[e.keyCode]) {
        this._moveDown();
      }
    }.bind(this);
  }

  onMousewheel(e) {
    if (this.lock) {
      e.preventDefault();
    }
    const delta = e.deltaY
      ? -e.deltaY
      : e.wheelDelta
      ? e.wheelDelta
      : -e.detail;
    this._init_scroll(e, delta);
  }

  onTouchStart(e) {
    this.ystart = e.touches[0].pageY;
  }

  onTouchMove(e) {
    this.yend = e.touches[0].pageY;
  }

  onTouchEnd(e) {
    if (this.ystart > this.yend + this.delta) {
      this._moveDown();
    }
    if (this.ystart < this.yend - this.delta) {
      this._moveUp();
    }
  }

  _init_scroll(event, delta) {
    if (delta < 0) {
      this._moveDown();
    } else if (delta > 0) {
      this._moveUp();
    }
  }

  _moveDown(delta) {
    if (this.isDisabled) {
      return;
    }
    if (this.status !== 'down') {
      this.status = 'down';
      this.onDown.emit();
    }
  }

  _moveUp(delta) {
    if (this.isDisabled) {
      return;
    }
    const cond = this.status !== 'up' && window.scrollY < this.top;
    if (cond) {
      this.status = 'up';
      this.onUp.emit();
    }
  }
}
